//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.DegreesAndSegmentsOrPatchesBuilder.js";
import "../no/SelectNXObject.js";
import "../no/SelectNXObjectList.js";
import "../GeometricUtilities/GeometricUtilities.ColorCodedRegionBuilder.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/FacetCollector.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"AngleValue",0,"Expression",0],[0,"BodyTypePreference",1,0],[0,"CoordinateSystem",1,"CoordinateSystem",0],[0,"DirectionOption",1,0],[0,"FacetCollector",0,"FacetCollector",0],[0,"IsAutomatic",1,0],[0,"IsBoundary",1,0],[0,"IsClosed",1,0],[0,"IsConstrained",1,0],[0,"IsHalfAngle",1,0],[0,"IsMultipleFeatures",1,0],[0,"IsRadius",1,0],[0,"IsSingleSurface",1,0],[0,"IsUniformU",1,0],[0,"IsUniformV",1,0],[1,"Parameterization",0,"GeometricUtilities.DegreesAndSegmentsOrPatchesBuilder",0],[0,"Point1",1,"Point",0],[0,"Point2",1,"Point",0],[0,"Point3",1,"Point",0],[0,"Point4",1,"Point",0],[1,"RadiusValue",0,"Expression",0],[1,"RejectionThresholdValue",0,"Expression",0],[0,"SmoothFactor",1,0],[1,"TargetObject",0,"SelectNXObject",1],[1,"TargetObjects",0,"SelectNXObjectList",0],[0,"TargetOption",1,0],[1,"TargetRegion",0,"GeometricUtilities.ColorCodedRegionBuilder",0],[0,"Type",1,0],[0,"Vector",1,"Direction",0],[0,"VectorConstraint",1,"Direction",0]],[[["originCsys","matCsys"],"EditCSYS",{},2,0]],[]];
SPLM.Features.FitSurfaceBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.FitSurfaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.FitSurfaceBuilder.Types = Object.freeze({
    "Fitfreeform" : "Fitfreeform", "Fitplane" : "Fitplane", "Fitsphere" : "Fitsphere", "Fitcylinder" : "Fitcylinder", "Fitcone" : "Fitcone"});

SPLM.Features.FitSurfaceBuilder.TargetType = Object.freeze({
    "Object" : "Object", "ColorRegion" : "ColorRegion", "FacetRegion" : "FacetRegion"});

SPLM.Features.FitSurfaceBuilder.DirectionType = Object.freeze({
    "BestFit" : "BestFit", "Vector" : "Vector", "Orientation" : "Orientation", "Csys" : "Csys"});

SPLM.Features.FitSurfaceBuilder.BodyType = Object.freeze({
    "Sheet" : "Sheet", "Solid" : "Solid"});

export default SPLM;